{
  "cancel": "Отмена",
  "continue": "Продолжить",
  "save": "Сохранить",
  "remove": "Удалить",
  "retry": "Повторить",
  "loading": "Загрузка…",
  "unknownOs": "Неизвестная ОС",
  "signOut": "Выйти",
  "language": "Язык",
  "requestId": "ID запроса: {{id}}",
  "unexpected": "Что-то пошло не так. Попробуйте ещё раз.",
  "close": "Закрыть"
}
